import { SET_CART_DRAWER } from '../../constants/actions'

const setCartDrawer = payload => ({
  type: SET_CART_DRAWER,
  ...payload,
})

export { setCartDrawer }
